"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var availableAppShape_1 = __importDefault(require("../availableAppShape"));
var Section_1 = __importDefault(require("./Section/Section"));
var appData_1 = __importDefault(require("../../../data/appData"));
var propTypes = {
    apps: prop_types_1.default.arrayOf(prop_types_1.default.shape(availableAppShape_1.default)),
};
function Sections(_a) {
    var apps = _a.apps;
    var i18n = useI18n_1.default();
    function getAppGroups(availableApps, _appsData) {
        var appGroups = [];
        _appsData.forEach(function (group) {
            var appsInGroup = group.apps
                .map(function (app) {
                var foundApp = availableApps.find(function (availableApp) { return availableApp.key === app.key; });
                if (foundApp) {
                    return __assign(__assign({}, app), { link: foundApp.url, title: foundApp.title });
                }
                return null;
            })
                .filter(function (app) { return app !== null; });
            if (appsInGroup.length > 0) {
                appGroups.push({ key: group.key, apps: appsInGroup });
            }
        });
        return appGroups;
    }
    return (react_1.default.createElement("div", { "data-testid": "sections" }, getAppGroups(apps, appData_1.default).map(function (group) { return (react_1.default.createElement(Section_1.default, { key: group.key, title: i18n.t("global_navigation.app_sections." + group.key), apps: group.apps })); })));
}
Sections.propTypes = propTypes;
exports.default = Sections;
//# sourceMappingURL=Sections.js.map